import CustomInput from "../CustomInput";
import styles from "./index.module.scss";
import search from "../../../assets/images/icons/search.svg";
import { ChangeEvent, useCallback, useEffect, useState } from "react";
import { useAppDispatch, useClassNames } from "../../../shared/hooks";
import { setSearchQuery } from "../../../store/app/app/app.store";
import { useIntl } from "react-intl";
import { useLocation } from "react-router-dom";

const SearchBar = () => {
  const [queryValue, setQueryValue] = useState<string>("");

  const intl = useIntl().formatMessage;

  const location = useLocation();

  const classNames = useClassNames([
    styles.SearchBar,
    queryValue ? styles["SearchBar--holdsValue"] : "",
  ]);

  const dispatch = useAppDispatch();

  const handleChange = useCallback(
    (e: ChangeEvent<HTMLInputElement>) => setQueryValue(e.target.value),
    []
  );

  useEffect(() => {
    const timeout = setTimeout(
      () =>
        dispatch(
          setSearchQuery(
            queryValue
              ? { value: queryValue, instance: location.pathname }
              : null
          )
        ),
      500
    );
    return () => {
      clearTimeout(timeout);
    };
  }, [dispatch, location.pathname, queryValue]);

  return (
    <CustomInput
      className={classNames}
      name={"sea_rch"}
      type="text"
      placeholder={intl({ id: "general.search" })}
      iconPath={search}
      value={queryValue}
      onChange={handleChange}
    />
  );
};

export default SearchBar;
